import { render, staticRenderFns } from "./btn_icon.vue?vue&type=template&id=7b163340&scoped=true&"
import script from "./btn_icon.vue?vue&type=script&lang=js&"
export * from "./btn_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b163340",
  null
  
)

export default component.exports